import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import './index.css';
import { applyTheme, getThemeChoice } from './lib/theme.ts';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root 엘리먼트를 찾을 수 없습니다.');
}

// 저장된 테마 선택을 meta(theme-color)까지 반영한다(부트 스크립트는 data-theme만 심는다).
applyTheme(getThemeChoice());

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA: 홈 화면 설치가 가능하도록 서비스 워커를 등록한다(캐시 없음 — public/sw.js 주석 참고).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* 등록 실패는 조용히 — 설치 배너만 안 뜰 뿐 앱은 정상 동작한다. */
    });
  });
}
